module.exports = __webpack_public_path__ + "img/logo_white.17efdbe9.svg";